import React from "react";
import styles from "./workingFile.module.scss";
import {
  formatAmountCalculate,
  getBalanceDue,
  getRoundOffAmount,
} from "../../utility";

function BankDetails({ amountData }) {
  console.log(amountData,"amountData");
  
  const totalAmount = amountData.totalAmount; // e.g., 58309.70

  const roundOfAmount = getRoundOffAmount(totalAmount); // 👉 0.70
  const balanceDue = getBalanceDue(totalAmount); // 👉 58309.00

  const updatedAmountData = {
    ...amountData,
    roundOfAmount,
    balanceDue,
  };
  return (
    <div className={styles.tableContainer}>
      <div className={""}>
        <div className={styles.invoiceAmountTable}>
          <table>
            <tbody>
              <tr>
                <td>
                  <b>SUBTOTAL</b>
                </td>
                <td>
                  ₹{formatAmountCalculate(updatedAmountData.actualAmount)}
                </td>
              </tr>
              <tr>
                <td>
                  <b>CGST 9%</b>
                </td>
                <td>₹{formatAmountCalculate(updatedAmountData.cgst)}</td>
              </tr>
              <tr>
                <td>
                  <b>SGST 9%</b>
                </td>
                <td>₹{formatAmountCalculate(updatedAmountData.sgst)}</td>
              </tr>
              <tr>
                <td>
                  <b>TOTAL GST 18%</b>
                </td>
                <td>₹{formatAmountCalculate(updatedAmountData.gst)}</td>
              </tr>
              <tr>
                <td>
                  <b>TOTAL</b>
                </td>
                <td>₹{formatAmountCalculate(updatedAmountData.totalAmount)}</td>
              </tr>
              <tr>
                <td>
                  <b>ROUND OFF AMOUNT</b>
                </td>
                <td>
                  ₹{formatAmountCalculate(updatedAmountData.roundOfAmount)}
                </td>
              </tr>
              <tr>
                <td>
                  <b>BALANCE DUE</b>
                </td>
                <td>₹{formatAmountCalculate(updatedAmountData.balanceDue)}</td>
              </tr>
              <tr>
                <td></td>
                <td
                  colSpan="2"
                  align="right"
                  style={{ fontSize: "17px", fontWeight: "700" }}
                >
                  ₹{formatAmountCalculate(updatedAmountData.balanceDue)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default BankDetails;
